import { Analytics } from '@johnlewispartnership/wtr-website-analytics';
// TODO: Types don't come through from the wtr-website-analytics package. Fix them!
const analytics = new Analytics(window.dataLayer);
// THIS FILE SHOULD NOT BE IMPORTED. WEBPACK WILL TAKE CARE OF LOADING IT IF NEEDED.
// This file is only loaded in the browser, because Webpack has an alias set up to load this file instead of'./index.ts'. The server will use the original file.
export const getAnalytics = () => analytics;
